import FetchSalesEnquiryAnaltyics from "@/v2/api/sales-enquiry/Analtyics";
import LoadingAnimation from "@/v2/components/ui/LoadingAnimation";
import parseUrlToQueryParams from "@/v2/utils/parseUrlToQueryParams";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

export default function SalesEqnuiryAnaltyicsPage() {
    const [searchParams, _setSearchParams] = useSearchParams();
    const queryParams = parseUrlToQueryParams(searchParams);

    const { skip, limit, search, filter } = queryParams;

    const { refetch, ...query } = useQuery({
        queryKey: ["sales-enquiry", skip, limit, search, filter],
        queryFn: () =>
            FetchSalesEnquiryAnaltyics({
                limit: limit ?? 20,
                skip: skip ?? 0,
                search: search,
                filter,
            }),
    });

    if (query.isLoading) return <LoadingAnimation />;

    return <div>Not Found</div>;
}
